import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const SEARCH_INITIAL: SEARCH_QUERY = {
  search: "",
  searchType: "all",
  searchResults: [],
};

const searchSlice = createSlice({
  name: "search",
  initialState: {
    ...SEARCH_INITIAL,
  },
  reducers: {
    SEARCH_UPDATE: (
      state,
      action: PayloadAction<{
        data?: SEARCH_QUERY;
        prop?: string;
        value?: string | Number | Object | [];
      }>,
    ) => {
      // console.log("SEARCHING", action.payload);
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { SEARCH_UPDATE } = searchSlice.actions;

export { searchSlice, SEARCH_INITIAL, SEARCH_UPDATE };
